import React from "react";
export const LineSkeleton = () => {
    return (React.createElement("div", { className: "onvo-flex-grow onvo-h-full onvo-relative" },
        React.createElement("svg", { className: "onvo-w-full onvo-h-full", viewBox: "0 0 100 50", preserveAspectRatio: "none" },
            React.createElement("polyline", { points: "0,50 20,35 40,40 60,25 80,30 100,0", className: "onvo-stroke-black/10 dark:onvo-stroke-white/10 onvo-fill-none onvo-stroke-[5px]" }))));
};
//# sourceMappingURL=line.js.map